module.exports = __webpack_public_path__ + "img/link.441767fc.svg";